import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import loadingIcon from '../assets/loadingIcon.svg';
import './Loading.scss';

const Loading = ({ text }) => {
    const { t } = useTranslation();

    return (
        <div className="loading-overlay">
            <img src={loadingIcon} alt="jerm" className='loading-icon' />
        </div>
    );
};

export default Loading;
